import React, { Component, createRef } from "react";
import './styles.scss';
import { generateKey } from "../../../infrastructure/helpers/react/commonHelper";
import OutsideClickDetector from "../OutsideClickDetector";
import CbComponent from '../../../types/common/Component';
import Spinner from "../Spinner/Spinner";
import CustomIcon from "../BootstrapIcons/Custom/CustomIcon";
import { ReactComponent as ChevronIcon } from '../BootstrapIcons/caret-down.svg';

interface Props {
    onOptionSelected: (option: CbComponent) => void;
    value: string;
    onClick?: () => void;
    containerClassName?: string;
    getOptions: () => Promise<CbComponent[]>;
    showOnlyDefaultTextAsSelected?: string;
}

interface State {
    selected: CbComponent | null;
    open: boolean;
    options: CbComponent[];
    showSpinner: boolean;
}

class CustomDropdown extends Component<Props, State> {

    private dropdownRef = createRef<HTMLDivElement>();

    constructor(props: Props) {
        super(props);

        this.state = {
            selected: null,
            open: false,
            options: [],
            showSpinner: false
        }

        this.selectOption = this.selectOption.bind(this);
        this.onClick = this.onClick.bind(this);
    }

    async onClick() {

        this.setState({ showSpinner: true });

        let options = await this.props.getOptions();

        if (!options.length) {
            this.setState({ open: false, showSpinner: false });
        }
        else {
            this.setState({ open: true, options, showSpinner: false });
        }
    }

    selectOption(option: CbComponent) {
        this.props.onOptionSelected(option);
        this.setState({ selected: option, open: false, showSpinner: false });
    };

    render() {
        return (
            <OutsideClickDetector onClickOuside={() => this.setState({ open: false })}>
                <div className='display-flex align-items-center'>
                    <div className={`select-container ${this.props.containerClassName || ''}`} ref={this.dropdownRef} onClick={this.onClick}>
                        <div className='display-flex align-items-center' onClick={this.onClick} >
                            <div className='select'>
                                <span className="custom-dropdown-header">
                                    {this.props.showOnlyDefaultTextAsSelected ? this.props.showOnlyDefaultTextAsSelected : this.state.selected?.name}
                                </span>
                            </div>
                            <CustomIcon className='dropdown-caretDown' icon={ChevronIcon} />
                            {this.state.showSpinner && <Spinner />}
                        </div>
                        {this.state.open &&
                            <ul className={`dropdown-list ${this.props.containerClassName || ''}`}>
                                {this.state.options.map((option) => {
                                    return <li key={generateKey()}
                                        className="dropdown-option"
                                        onClick={() => this.selectOption(option)}
                                    >
                                        {option.name}
                                    </li>
                                })}
                            </ul>
                        }
                    </div>
                </div>
            </OutsideClickDetector>
        );
    }
}

export default CustomDropdown;